import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2"; // Import SweetAlert

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  // Check for token in sessionStorage to persist session after refresh
  useEffect(() => {
    const token = sessionStorage.getItem("authToken"); // Get token from sessionStorage
    if (token) {
      setIsAuthenticated(true); // Mark as authenticated if token exists
    }
  }, []);

  // Login function to handle user authentication
  const login = (credentials) => {
    if (
      credentials.username === "vaaar@admin.in" &&
      credentials.password === "poorpeople@1"
    ) {
      const token =
        "B9zzei20pAcMcPeababKf5k1j0phoYwdiyh5jxOxyU5jGqqbL7cAkecsdSPBGQfR"; // Simulate token
      sessionStorage.setItem("authToken", token); // Store token in sessionStorage
      setIsAuthenticated(true); // Mark user as authenticated
      navigate("/home"); // Redirect to home page
    } else {
      // Show error alert for invalid credentials
      Swal.fire({
        icon: "error",
        title: "Invalid Credentials",
        text: "Please check your username and password.",
        confirmButtonColor: "#d33",
      });
    }
  };

  // Logout function to handle user logout
  const logout = () => {
    sessionStorage.removeItem("authToken"); // Remove token from sessionStorage
    setIsAuthenticated(false); // Mark user as logged out
    navigate("/"); // Redirect to login page
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use the AuthContext
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
